import { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

function TrailerPage() {
  const [africaNews, setAfricaNews] = useState([]);
  const [gamesNews, setGamesNews] = useState([]);
  const [loadingAfricaNews, setLoadingAfricaNews] = useState(true);
  const [loadingGamesNews, setLoadingGamesNews] = useState(true);

  const africaPrevRef = useRef(null);
  const africaNextRef = useRef(null);
  const gamesPrevRef = useRef(null);
  const gamesNextRef = useRef(null);

  // ================= AFRICA NEWS =================
  useEffect(() => {
    const fetchAfricaNews = async () => {
      try {
        setLoadingAfricaNews(true);

        const response = await fetch(
          "https://saurav.tech/NewsAPI/top-headlines/category/general/in.json"
        );

        if (!response.ok) throw new Error("API Failed");

        const data = await response.json();

        if (data.articles && data.articles.length > 0) {
          const africaFiltered = data.articles.filter(
            (article) =>
              article.title &&
              (article.title.toLowerCase().includes("africa") ||
                article.title.toLowerCase().includes("african") ||
                article.description?.toLowerCase().includes("africa"))
          );

          const articlesToUse =
            africaFiltered.length > 0 ? africaFiltered : data.articles;

          setAfricaNews(
            articlesToUse.slice(0, 8).map((article, index) => ({
              id: index + 1,
              title: article.title || "Africa News",
              description:
                article.description ||
                article.content?.substring(0, 150) ||
                "Latest Africa news update.",
              image: article.urlToImage || "/assets/video.webp",
              url: article.url || "#",
              publishedAt:
                article.publishedAt || new Date().toISOString(),
            }))
          );
        }
      } catch (error) {
        console.error("Africa News Error:", error);
      } finally {
        setLoadingAfricaNews(false);
      }
    };

    fetchAfricaNews();
    const interval = setInterval(fetchAfricaNews, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // ================= GAMES NEWS =================
  useEffect(() => {
    const fetchGamesNews = async () => {
      try {
        setLoadingGamesNews(true);

        const response = await fetch(
          "https://saurav.tech/NewsAPI/top-headlines/category/technology/in.json"
        );

        if (!response.ok) throw new Error("API Failed");

        const data = await response.json();

        if (data.articles && data.articles.length > 0) {
          const gamingFiltered = data.articles.filter(
            (article) =>
              article.title &&
              (article.title.toLowerCase().includes("gaming") ||
                article.title.toLowerCase().includes("game") ||
                article.title.toLowerCase().includes("esports") ||
                article.description?.toLowerCase().includes("gaming"))
          );

          const articlesToUse =
            gamingFiltered.length > 0 ? gamingFiltered : data.articles;

          setGamesNews(
            articlesToUse.slice(0, 8).map((article, index) => ({
              id: index + 1,
              title: article.title || "Gaming News",
              description:
                article.description ||
                article.content?.substring(0, 150) ||
                "Latest gaming news update.",
              image: article.urlToImage || "/assets/video.webp",
              url: article.url || "#",
              publishedAt:
                article.publishedAt || new Date().toISOString(),
            }))
          );
        }
      } catch (error) {
        console.error("Games News Error:", error);
      } finally {
        setLoadingGamesNews(false);
      }
    };

    fetchGamesNews();
    const interval = setInterval(fetchGamesNews, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-[#181720] overflow-x-hidden">

      {/* ================= TOP BANNER ================= */}
      <div
        className="text-white min-h-[260px] md:min-h-[320px] lg:min-h-[380px] p-6 bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/assets/banner-about-bg.webp')" }}
      >

        {/* 🔴 RED COLOR OVERLAY */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#ff003c]/40 to-[#6a00ff]/40 mix-blend-overlay"></div>

        <div className="w-full max-w-6xl text-center md:text-left">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-6 md:mt-10">
            News
          </h2>
<div className="flex gap-2 text-sm text-gray-300 mt-3">
              <span>Home</span>
              <span>›</span>
              <span>Pages</span>
              <span>›</span>
           <span className="text-[#ff003c] font-semibold">News</span>
          </div>
        </div>
      </div>

     {/* ================= AFRICA NEWS ================= */}
<div className="py-16 px-6 bg-[#0b0b15] relative overflow-hidden">

  {/* 🔥 GLOW */}
  <div className="absolute left-[-200px] top-0 w-[300px] h-[300px] rounded-full 
  bg-gradient-to-br from-[#ff003c] to-[#6a00ff] opacity-10 blur-[120px]"></div>

  <div className="max-w-7xl mx-auto relative z-10">

    <div className="flex justify-between items-center mb-12">
      <h2 className="text-white text-3xl font-bold">
        <span className="text-[#ff003c]">Africa</span> News
      </h2>

      <div className="flex gap-3">
        <button ref={africaPrevRef}
          className="bg-[#1f1f35] hover:bg-gradient-to-r hover:from-[#ff003c] hover:to-[#6a00ff] 
          w-12 h-12 rounded-lg flex items-center justify-center transition-all">
          <IoIosArrowBack size={20} color="#fff" />
        </button>

        <button ref={africaNextRef}
          className="bg-[#1f1f35] hover:bg-gradient-to-r hover:from-[#ff003c] hover:to-[#6a00ff] 
          w-12 h-12 rounded-lg flex items-center justify-center transition-all">
          <IoIosArrowForward size={20} color="#fff" />
        </button>
      </div>
    </div>

    {loadingAfricaNews ? (
      <div className="text-white text-center py-20">Loading Africa news...</div>
    ) : (
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={25}
        slidesPerView={1}
        navigation={{
          prevEl: africaPrevRef.current,
          nextEl: africaNextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = africaPrevRef.current;
          swiper.params.navigation.nextEl = africaNextRef.current;
        }}
        loop={africaNews.length > 3}
        autoplay={{ delay: 4000 }}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4 },
        }}
      >
        {africaNews.map((news) => (
          <SwiperSlide key={news.id}>
            <a
              href={news.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-[#141422] rounded-2xl p-5 
              border border-[#ffffff10] 
              hover:border-[#ff003c] 
              transition-all duration-300 
              hover:shadow-[0_0_20px_rgba(255,0,60,0.4)]
              min-h-[320px] flex flex-col"
            >
              <img
                src={news.image}
                alt={news.title}
                className="w-full h-40 object-cover rounded-lg mb-4"
                onError={(e) => (e.target.src = "/assets/video.webp")}
              />

              <h3 className="text-white text-lg font-bold mb-2 line-clamp-2 
              group-hover:text-[#ff003c]">
                {news.title}
              </h3>

              <p className="text-gray-400 text-sm flex-grow line-clamp-3">
                {news.description}
              </p>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    )}
  </div>
</div>


{/* ================= GAMING NEWS ================= */}
<div className="py-16 px-6 bg-[#0b0b15] pb-32 relative overflow-hidden">

  {/* 🔥 GLOW */}
  <div className="absolute right-[-200px] bottom-0 w-[300px] h-[300px] rounded-full 
  bg-gradient-to-tr from-[#ff003c] to-[#6a00ff] opacity-10 blur-[120px]"></div>

  <div className="max-w-7xl mx-auto relative z-10">

    <div className="flex justify-between items-center mb-12">
      <h2 className="text-white text-3xl font-bold">
        <span className="text-[#ff003c]">Gaming</span> News
      </h2>

      <div className="flex gap-3">
        <button ref={gamesPrevRef}
          className="bg-[#1f1f35] hover:bg-gradient-to-r hover:from-[#ff003c] hover:to-[#6a00ff] 
          w-12 h-12 rounded-lg flex items-center justify-center transition-all">
          <IoIosArrowBack size={20} color="#fff" />
        </button>

        <button ref={gamesNextRef}
          className="bg-[#1f1f35] hover:bg-gradient-to-r hover:from-[#ff003c] hover:to-[#6a00ff] 
          w-12 h-12 rounded-lg flex items-center justify-center transition-all">
          <IoIosArrowForward size={20} color="#fff" />
        </button>
      </div>
    </div>

    {loadingGamesNews ? (
      <div className="text-white text-center py-20">Loading gaming news...</div>
    ) : (
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={25}
        slidesPerView={1}
        navigation={{
          prevEl: gamesPrevRef.current,
          nextEl: gamesNextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = gamesPrevRef.current;
          swiper.params.navigation.nextEl = gamesNextRef.current;
        }}
        loop={gamesNews.length > 3}
        autoplay={{ delay: 4000 }}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4 },
        }}
      >
        {gamesNews.map((news) => (
          <SwiperSlide key={news.id}>
            <a
              href={news.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-[#141422] rounded-2xl p-5 
              border border-[#ffffff10] 
              hover:border-[#ff003c] 
              transition-all duration-300 
              hover:shadow-[0_0_20px_rgba(255,0,60,0.4)]
              min-h-[320px] flex flex-col"
            >
              <img
                src={news.image}
                alt={news.title}
                className="w-full h-40 object-cover rounded-lg mb-4"
                onError={(e) => (e.target.src = "/assets/video.webp")}
              />

              <h3 className="text-white text-lg font-bold mb-2 line-clamp-2 
              group-hover:text-[#ff003c]">
                {news.title}
              </h3>

              <p className="text-gray-400 text-sm flex-grow line-clamp-3">
                {news.description}
              </p>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    )}
  </div>
</div>

    </div>
  );
}

export default TrailerPage;